import Udesk from 'Udesk';
import Component from './template';
import _Oauth from './oauth';

export default Udesk.react.udeskify(Component);
export const Oauth = Udesk.react.udeskify(_Oauth);
export const OauthCallback = Udesk.react.udeskify(_Oauth);
